<template>
  <div class="home-middle">
    <title-one :title="'达州市高新区地图'" />
    <div class="rank-one left">
      <map-bg :show-axis="false">
        <template slot="label">
          <agency-label
            v-for="(item, index) in agencyList"
            :key="index"
            :size="item.size || 1"
            :agency-name="item.name"
            :active="selectIndex===index"
            class="agency-label"
            :style="{top: `${item.y}px`, left: `${item.x}px`,'z-index': selectIndex===index? 22 : 1}"
            @click.native="selectIndexFn(item, index)"
          />
        </template>
      </map-bg>
    </div>
    <date-energy class="m-top" :date-energy-consumption="dateEnergyConsumption" />
  </div>
</template>

<script>
import TitleOne from '@/components/TitleOne/TitleOne'
import AgencyLabel from '../../../components/AgencyLabel/AgencyLabel'
import { mapGetters, mapState } from 'vuex'
import MapBg from '@/views/Home/components/MapBg'
import DateEnergy from '@/views/Home/components/MapItem/DateEnergy'
import { deepCopy } from '@/utils/tool'
export default {
  name: 'HomeMiddle',
  components: { DateEnergy, MapBg, AgencyLabel, TitleOne },
  data() {
    return {
      mapInnerPos: {
        x: 0,
        y: 0
      },
      mapBg: require('../images/map-bg.png'),
      selectIndex: 0,
      agencyTimer: null,
      spaceTime: 1000 * 10,
      agencyList: [],
      dateEnergyConsumption: {}
    }
  },
  computed: {
    ...mapState({
      'initAgencyList': 'agencyList'
    }),
    ...mapGetters({
      'initDateEnergyConsumption': 'dateEnergyConsumption'
    })
  },
  watch: {
    initAgencyList: {
      handler(newV, oldV) {
        this.agencyList = deepCopy({ val: this.initAgencyList }).val
      },
      immediate: true,
      deep: true
    },
    initDateEnergyConsumption: {
      handler(newV, oldV) {
        this.dateEnergyConsumption = deepCopy(newV)
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.agencyInterval()
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.agencyTimer)
    this.agencyTimer = null
    next()
  },
  beforeDestroy() {
    clearInterval(this.agencyTimer)
    this.agencyTimer = null
  },
  methods: {
    agencyInterval() {
      this.agencyTimer = setInterval(() => {
        if (this.selectIndex <= this.agencyList.length - 2) {
          this.selectIndex += 1
        } else {
          this.selectIndex = 0
        }
        this.$store.commit('changeCurAgency', this.agencyList[this.selectIndex])
      }, this.spaceTime)
    },
    getMousePos(event) {
      this.mapInnerPos.x = event.offsetX || event.layerX
      this.mapInnerPos.y = event.offsetY || event.layerY
    },
    selectIndexFn(item, index) {
      clearInterval(this.agencyTimer)
      this.selectIndex = index
      this.$store.commit('changeCurAgency', item)
      this.agencyInterval()
    }
  }
}
</script>

<style lang="less" scoped>
  .rank-one{
    width: 100%;
    height: 864px;
    background: url("../images/middle-1.png") top left no-repeat;
    background-size: 100% 100%;
    padding: 10px 4px 4px 4px;
    .agency-label{
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-50%, -50%);
    }
  }
  .rank-two{
    width: 100%;
    height: 294px;
    background: url("../images/middle-2.png") top left no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-start;
    position: relative;
    .m-left{
      padding: 20px 10px 20px 20px;
    }
    .center-one{
      left: 121px;
    }
    .center-two{
      left: 399px;
    }
    .center-three{
      left: 677px;
    }
    .center-one, .center-two, .center-three{
      position: absolute;
      top: 67px;
    }
    .ring-name{
      font-size: 24px;
      position: absolute;
      top: 230px;
    }
    .ring-one{
      left: 175px;
    }
    .ring-two{
      left: 438px;
    }
    .ring-three{
      left: 734px;
    }
  }
  .m-top{
    margin-top: 16px;
  }
  .left{
    position: relative;
    top: -6px;
  }
</style>
